(() => {
  function initialize(root) {
    if (root.dataset.stainlessInitialized === 'true') return;
    root.dataset.stainlessInitialized = 'true';
    const filters = root.querySelector('[data-stainless-filters]');
    const grid = root.querySelector('[data-stainless-grid]');
    const status = root.querySelector('[data-stainless-filter-status]');
    const pieces = [...root.querySelectorAll('[data-stainless-category]')];
    if (filters && grid) {
      filters.hidden = false;
      filters.querySelectorAll('[data-stainless-filter]').forEach(button => {
        button.addEventListener('click', () => {
          const category = button.dataset.stainlessFilter;
          filters.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
          grid.dataset.filter = category;
          pieces.forEach(piece => { piece.hidden = category !== 'all' && piece.dataset.stainlessCategory !== category; });
          if (status) {
            const count = pieces.filter(piece => !piece.hidden).length;
            status.textContent = `${count} ${count === 1 ? 'piece' : 'pieces'} shown${category === 'all' ? '' : `: ${category === 'fountain' ? 'fountains' : category === 'commission' ? 'commissions' : 'sculpture'}`}.`;
          }
        });
      });
    }
    const productPanel = root.querySelector('[data-stainless-product-panel]');
    const variantSelect = productPanel?.querySelector('[data-stainless-variant-select]');
    const interestField = root.querySelector('[data-stainless-interest-field]');
    const projectField = root.querySelector('[data-stainless-project-field]');
    const intentField = root.querySelector('[data-stainless-intent-field]');
    const inquiryProduct = root.querySelector('[data-stainless-inquiry-product]');
    const inquiryUrl = root.querySelector('[data-stainless-inquiry-url]');
    const inquiryVariant = root.querySelector('[data-stainless-inquiry-variant]');
    const inquiryConcept = root.querySelector('[data-stainless-inquiry-concept]');
    const conceptSelection = root.querySelector('[data-stainless-concept-selection]');
    const currentPiece = root.dataset.stainlessProductTitle || inquiryProduct?.value || '';
    const currentUrl = root.dataset.stainlessProductUrl || inquiryUrl?.value || '';
    const initialConfiguration = inquiryVariant?.value || '';
    const configuration = () => variantSelect?.selectedOptions[0]?.dataset.configuration || initialConfiguration;
    const modes = ['ask-piece', 'customize-piece', 'original-commission'];
    const urls = { 'Seated Figure':'/products/hok-seated-figure-sculpture', 'Circular Fountain':'/products/hok-circular-fountain', 'Faceted Fountain':'/products/hok-faceted-fountain', 'Brushed Open Form':'/products/hok-brushed-open-form', 'Mirror Stone Pair':'/products/hok-mirror-stone-pair', 'Custom Sculpture Commission':'/products/hok-custom-sculpture-commission' };
    const isCommission = (piece, url) => piece === 'Custom Sculpture Commission' || /\/products\/hok-custom-sculpture-commission(?:[?#]|$)/.test(url || '');
    function showSelection() {
      const line = root.querySelector('[data-stainless-inquiry-selection]');
      if (!line) return;
      const piece = inquiryProduct?.value || '';
      line.textContent = piece + (piece && inquiryVariant?.value ? ` · ${inquiryVariant.value}` : '');
      line.hidden = !piece;
    }
    function setContext(piece, url, selected) {
      if (inquiryProduct) inquiryProduct.value = piece || '';
      if (inquiryUrl) inquiryUrl.value = url || '';
      if (inquiryVariant) inquiryVariant.value = selected || '';
      showSelection();
    }
    function applyIntent(mode, context) {
      if (!intentField || !modes.includes(mode)) return;
      intentField.value = mode;
      const concept = mode === 'original-commission' ? (context?.concept || '') : '';
      if (inquiryConcept) inquiryConcept.value = concept;
      if (conceptSelection) { conceptSelection.textContent = concept ? `Design direction: ${concept}` : ''; conceptSelection.hidden = !concept; }
      const option = intentField.selectedOptions[0];
      const mappings = [
        ['[data-stainless-inquiry-heading]', 'stainlessIntentHeading'],
        ['[data-stainless-inquiry-copy]', 'stainlessIntentCopy'],
        ['[data-stainless-inquiry-body-label]', 'stainlessIntentBodyLabel'],
        ['[data-stainless-inquiry-submit-label]', 'stainlessIntentSubmitLabel']
      ];
      mappings.forEach(([selector, key]) => { const element = root.querySelector(selector); if (element && option?.dataset[key]) element.textContent = option.dataset[key]; });
      const body = root.querySelector('[data-stainless-inquiry-body]');
      if (body && option?.dataset.stainlessIntentPlaceholder) body.placeholder = option.dataset.stainlessIntentPlaceholder;
      // Never replace a visitor's written message when they change inquiry paths.
      if (mode === 'original-commission') {
        const explicitCommission = context && isCommission(context.piece, context.url);
        if (explicitCommission || (!context && isCommission(currentPiece, currentUrl))) {
          setContext(explicitCommission ? context.piece : currentPiece, explicitCommission ? context.url : currentUrl, isCommission(currentPiece, currentUrl) ? configuration() : '');
        } else setContext('', '', '');
        if (interestField) interestField.value = 'Custom or original commission';
      } else {
        const piece = context ? context.piece : inquiryProduct?.value || (isCommission(currentPiece, currentUrl) ? '' : currentPiece);
        const url = context ? context.url || urls[piece] || '' : inquiryUrl?.value || (piece === currentPiece ? currentUrl : urls[piece] || '');
        setContext(piece, url, piece && piece === currentPiece ? configuration() : (context ? '' : inquiryVariant?.value || ''));
        if (interestField) interestField.value = piece && [...interestField.options].some(item => item.value === piece) ? piece : 'Help choosing';
      }
    }
    if (intentField) {
      // Native product titles may be longer than the collection's display names.
      // Keep the initial inquiry tied to the actual current product and size.
      if (root.dataset.stainlessProductTitle && currentUrl) setContext(currentPiece, currentUrl, configuration());
      const desired = new URLSearchParams(window.location.search).get('inquiry');
      applyIntent(modes.includes(desired) ? desired : intentField.value);
      intentField.addEventListener('change', () => applyIntent(intentField.value));
      interestField?.addEventListener('change', () => {
        const piece = interestField.value;
        if (piece === 'Custom or original commission') applyIntent('original-commission');
        else applyIntent(intentField.value === 'original-commission' ? 'ask-piece' : intentField.value, { piece: piece === 'Help choosing' ? '' : piece, url: urls[piece] || '' });
      });
    }
    root.querySelectorAll('[data-stainless-interest], [data-stainless-project], [data-stainless-intent]').forEach(link => {
      link.addEventListener('click', () => {
        if (projectField && link.dataset.stainlessProject) projectField.value = link.dataset.stainlessProject;
        if (intentField && (link.dataset.stainlessIntent || link.dataset.stainlessInterest)) {
          const mode = modes.includes(link.dataset.stainlessIntent) ? link.dataset.stainlessIntent : (link.dataset.stainlessInterest === 'Custom or original commission' ? 'original-commission' : 'ask-piece');
          const requestedPiece = link.dataset.stainlessPiece || (link.dataset.stainlessInterest !== 'Custom or original commission' ? link.dataset.stainlessInterest : '') || '';
          const piece = requestedPiece === 'Help choosing' ? '' : requestedPiece;
          const url = link.dataset.stainlessProductUrl || (piece === currentPiece ? currentUrl : urls[piece] || '');
          applyIntent(mode, { piece, url, concept: link.dataset.stainlessConcept });
        } else if (interestField && link.dataset.stainlessInterest) interestField.value = link.dataset.stainlessInterest;
      });
    });
    if (variantSelect) {
      const sizeChoices = [...productPanel.querySelectorAll('[data-stainless-size-choice]')];
      function updateVariant() {
        const selected = variantSelect.selectedOptions[0];
        if (!selected) return;
        const available = selected.dataset.available === 'true';
        const price = productPanel.querySelector('[data-stainless-variant-price]');
        const button = productPanel.querySelector('[data-stainless-add-to-cart]');
        const label = productPanel.querySelector('[data-stainless-cart-label]');
        const delivery = productPanel.querySelector('[data-stainless-variant-status]');
        if (price) price.textContent = selected.dataset.price;
        const selectedPrice = productPanel.querySelector('[data-stainless-selected-price]');
        if (selectedPrice) selectedPrice.hidden = selected.dataset.priceCents === productPanel.dataset.stainlessMinPriceCents;
        const dimensions = productPanel.querySelector('[data-stainless-selected-dimensions]');
        if (dimensions) dimensions.textContent = selected.dataset.configuration || selected.textContent;
        if (inquiryVariant && (!intentField || inquiryProduct?.value === currentPiece)) inquiryVariant.value = selected.dataset.configuration || selected.textContent;
        showSelection();
        if (button) button.disabled = !available;
        if (label) label.textContent = available ? 'Add to Cart' : 'Currently unavailable';
        if (delivery) delivery.textContent = available ? (productPanel.dataset.stainlessAvailableMessage || 'Made to order. Production and delivery timing are confirmed with you after ordering.') : 'This configuration is currently unavailable to order. Contact us about your project.';
        sizeChoices.forEach(choice => { const active = choice.dataset.stainlessSizeChoice === selected.value; choice.setAttribute('aria-checked', String(active)); choice.tabIndex = active ? 0 : -1; });
        const url = new URL(window.location.href);
        url.searchParams.set('variant', selected.value);
        window.history.replaceState({}, '', url.toString());
        root.dispatchEvent(new CustomEvent('stainless:variant-change', { detail:{ id:selected.value, configuration:selected.dataset.configuration || selected.textContent, title:currentPiece } }));
      }
      variantSelect.addEventListener('change', updateVariant);
      if (sizeChoices.length) {
        productPanel.querySelector('[data-stainless-size-picker]').hidden = false;
        variantSelect.hidden = true;
        const nativeLabel = productPanel.querySelector('[data-stainless-native-variant-label]');
        if (nativeLabel) nativeLabel.hidden = true;
        sizeChoices.forEach((choice,index) => {
          const choose = () => { variantSelect.value = choice.dataset.stainlessSizeChoice; variantSelect.dispatchEvent(new Event('change',{bubbles:true})); };
          choice.addEventListener('click', choose);
          choice.addEventListener('keydown', event => {
            let next;
            if (['ArrowRight','ArrowDown'].includes(event.key)) next = (index + 1) % sizeChoices.length;
            else if (['ArrowLeft','ArrowUp'].includes(event.key)) next = (index + sizeChoices.length - 1) % sizeChoices.length;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = sizeChoices.length - 1;
            if (next === undefined) return;
            event.preventDefault(); sizeChoices[next].click(); sizeChoices[next].focus();
          });
        });
      }
    }
    root.querySelectorAll('[data-stainless-gallery]').forEach(gallery => {
      const thumbs = [...gallery.querySelectorAll('[data-stainless-gallery-thumb]')];
      const image = gallery.querySelector('[data-stainless-gallery-image]');
      const open = gallery.querySelector('[data-stainless-gallery-open]');
      const dialog = gallery.querySelector('[data-stainless-gallery-dialog]');
      const zoomImage = gallery.querySelector('[data-stainless-gallery-zoom-image]');
      let active = 0;
      const show = index => {
        active = (index + thumbs.length) % thumbs.length;
        const thumb = thumbs[active];
        if (!thumb) return;
        [image,zoomImage].forEach(img => { if (!img) return; img.src = thumb.dataset.src; img.alt = thumb.dataset.alt; img.width = Number(thumb.dataset.width); img.height = Number(thumb.dataset.height); });
        open.href = thumb.dataset.src;
        thumbs.forEach((item,i) => item.setAttribute('aria-pressed',String(i === active)));
        const caption = gallery.querySelector('[data-stainless-gallery-caption]');
        const zoomCaption = gallery.querySelector('[data-stainless-gallery-zoom-caption]');
        if (caption) caption.textContent = thumb.dataset.caption;
        if (zoomCaption) zoomCaption.textContent = thumb.dataset.caption;
        const count = gallery.querySelector('[data-stainless-gallery-count]');
        if (count) count.textContent = `${String(active+1).padStart(2,'0')} / ${String(thumbs.length).padStart(2,'0')}`;
      };
      if (!thumbs.length || !image || !open) return;
      gallery.querySelector('[data-stainless-gallery-thumbnails]').hidden = false;
      thumbs.forEach((thumb,index) => thumb.addEventListener('click',()=>show(index)));
      open.addEventListener('click',event => { if (typeof dialog?.showModal !== 'function') return; event.preventDefault(); show(active); dialog.showModal(); });
      gallery.querySelector('[data-stainless-gallery-close]')?.addEventListener('click',()=>dialog.close());
      gallery.querySelector('[data-stainless-gallery-previous]')?.addEventListener('click',()=>show(active-1));
      gallery.querySelector('[data-stainless-gallery-next]')?.addEventListener('click',()=>show(active+1));
      dialog?.addEventListener('keydown',event => { if (event.key === 'ArrowRight') { event.preventDefault(); show(active+1); } else if (event.key === 'ArrowLeft') { event.preventDefault(); show(active-1); } });
    });
    const previewNote = root.querySelector('[data-stainless-preview-note]');
    if (previewNote) {
      const params = new URLSearchParams(window.location.search);
      previewNote.hidden = !(window.Shopify?.theme?.role !== 'main' || Boolean(window.Shopify?.designMode) || params.has('preview_theme_id'));
    }
    const formResult = root.querySelector('[data-stainless-form-result]');
    if (formResult) formResult.focus({ preventScroll:true });
    // Native Shopify forms retain their submission, validation and order behavior.
  }
  document.querySelectorAll('[data-stainless-world]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-stainless-world]').forEach(initialize));
})();

/* Stainless inquiry measurement. Shopify owns the contact POST and Google tag loading.
 * Contact values never enter these events. A queued event is not a delivery receipt.
 */
(() => {
  const PENDING = 'hok.stainless.inquiry.pending.v1';
  const ATTRIBUTION = 'hok.stainless.attribution.v1';
  const TTL = 30 * 60 * 1000;
  const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  const pieces = { 'Seated Figure': 'seated-figure', 'Circular Fountain': 'circular-fountain', 'Faceted Fountain': 'faceted-fountain', 'Brushed Open Form': 'brushed-open-form', 'Mirror Stone Pair': 'mirror-stone-pair', 'Custom or original commission': 'commission', 'Help choosing': 'undecided' };
  const projectTypes = { 'Home / garden': 'residential', 'Hospitality / commercial': 'commercial', 'Architect / designer / project team': 'design-trade', 'Other project': 'other' };
  const read = key => { try { return JSON.parse(window.sessionStorage.getItem(key)); } catch { return null; } };
  const write = (key, value) => {
    try { if (value) window.sessionStorage.setItem(key, JSON.stringify(value)); else window.sessionStorage.removeItem(key); return true; } catch { return false; }
  };
  const fresh = at => Number.isFinite(at) && Date.now() >= at && Date.now() - at <= TTL;
  const permission = method => { try { return window.Shopify?.customerPrivacy?.[method]?.() === true; } catch { return false; } };
  const attributionFrom = params => {
    const result = {};
    const rules = {
      utm_source: /^google$/, utm_medium: /^(cpc|ppc|paid-search)$/,
      utm_campaign: /^stainless(?:[-_][a-z0-9]+){1,10}$/,
      utm_content: /^(collection|sculpture|fountains|commission|residential|design-trade|\d{1,20})$/,
      utm_id: /^\d{1,20}$/,
      campaignid: /^\d{1,20}$/, adgroupid: /^\d{1,20}$/, creative: /^\d{1,20}$/,
      device: /^[cmt]$/, network: /^[gsdxy]$/,
      gclid: /^[A-Za-z0-9_-]{8,256}$/, gbraid: /^[A-Za-z0-9_-]{8,256}$/, wbraid: /^[A-Za-z0-9_-]{8,256}$/
    };
    for (const [key, rule] of Object.entries(rules)) {
      const value = params.get(key);
      if (typeof value === 'string' && rule.test(value)) result[key] = value;
    }
    return result;
  };
  const initialize = marker => {
    if (marker.dataset.stainlessMeasured === 'true') return;
    marker.dataset.stainlessMeasured = 'true';
    const form = marker.closest('form');
    if (!form || form.dataset.reviewOnly === 'true') return;
    const state = marker.dataset.stainlessServerStatus;
    const params = new URLSearchParams(window.location.search);
    const returnedReference = params.get('hok_inquiry_ref');
    const preview = marker.dataset.stainlessReview !== 'false' || window.Shopify?.theme?.role !== 'main' ||
      Boolean(window.Shopify?.designMode) || params.has('preview_theme_id');
    const gaDestination = /^G-[A-Z0-9]+$/.test(marker.dataset.stainlessGaDestination || '') ? marker.dataset.stainlessGaDestination : '';
    const adsDestination = /^AW-\d+\/[A-Za-z0-9_-]+$/.test(marker.dataset.stainlessAdsDestination || '') ? marker.dataset.stainlessAdsDestination : '';
    const receipt = { version: 1, server: state, tracking: 'awaiting-submission', attribution: 'not-captured', ga: preview ? 'review-suppressed' : 'not-attempted', ads: preview ? 'review-suppressed' : 'not-attempted' };
    const report = () => {
      receipt.tagAvailable = typeof window.gtag === 'function';
      receipt.privacyApiAvailable = Boolean(window.Shopify?.customerPrivacy);
      receipt.reviewContext = preview;
      receipt.themeRole = ['main', 'unpublished', 'development'].includes(window.Shopify?.theme?.role) ? window.Shopify.theme.role : 'unknown';
      marker.dataset.stainlessTracking = receipt.tracking;
      marker.dataset.stainlessGaStatus = receipt.ga;
      marker.dataset.stainlessAdsStatus = receipt.ads;
      marker.textContent = JSON.stringify(receipt);
    };
    const valid = pending => Boolean(pending && pending.form === form.id && UUID.test(pending.id) && fresh(pending.at) &&
      Object.values(pieces).includes(pending.piece) && ['undecided', ...Object.values(projectTypes)].includes(pending.project) &&
      typeof pending.ga === 'boolean' && typeof pending.ads === 'boolean' && typeof pending.review === 'boolean');
    const syncAttribution = () => {
      const field = form.querySelector('[data-stainless-attribution-field]');
      if (field) field.value = '';
      if (!window.Shopify?.customerPrivacy) { receipt.attribution = 'privacy-api-unavailable'; return; }
      if (!permission('marketingAllowed')) {
        write(ATTRIBUTION, null);
        receipt.attribution = 'consent-not-allowed';
        return;
      }
      const current = attributionFrom(params);
      let saved = read(ATTRIBUTION);
      if (Object.keys(current).length && state !== 'success') {
        // Keep one latest landing touch; do not combine a new ad with an old click ID.
        const candidate = { at: Date.now(), data: current };
        saved = write(ATTRIBUTION, candidate) ? candidate : null;
      }
      if (saved && fresh(saved.at) && saved.data && typeof saved.data === 'object') {
        const safe = attributionFrom(new URLSearchParams(saved.data));
        if (field) field.value = JSON.stringify(safe);
        receipt.attribution = Object.keys(safe).length ? 'captured-with-marketing-permission' : 'not-captured';
      } else {
        write(ATTRIBUTION, null);
        receipt.attribution = 'not-captured';
      }
    };
    if (state === 'error') { write(PENDING, null); receipt.tracking = 'server-error'; }
    if (state === 'ready' || state === 'error') {
      form.addEventListener('submit', event => {
        if (event.defaultPrevented || !form.checkValidity()) return;
        const reference = form.querySelector('[data-stainless-inquiry-reference]');
        const returnTo = form.querySelector('input[name="return_to"]');
        if (reference) reference.value = '';
        if (returnTo) returnTo.value = 'back';
        syncAttribution();
        const analytics = permission('analyticsProcessingAllowed');
        const marketing = permission('marketingAllowed');
        if (!analytics && !marketing) {
          write(PENDING, null); receipt.tracking = 'measurement-consent-not-allowed'; report(); return;
        }
        let id;
        try { id = window.crypto.randomUUID(); } catch { receipt.tracking = 'reference-unavailable'; report(); return; }
        if (!reference || !returnTo || !UUID.test(id)) { receipt.tracking = 'native-reference-route-unavailable'; report(); return; }
        const pending = {
          id, form: form.id, at: Date.now(), review: preview,
          piece: pieces[form.querySelector('[data-stainless-interest-field]')?.value] || 'undecided',
          project: projectTypes[form.querySelector('[data-stainless-project-field]')?.value] || 'undecided',
          ga: false, ads: false
        };
        if (!write(PENDING, pending)) { receipt.tracking = 'storage-unavailable'; report(); return; }
        reference.value = id;
        const returnParams = new URLSearchParams();
        if (['stainless-steel-statues', 'stainless-steel-statues-google', 'stainless-steel-commission', 'stainless-current', 'stainless-current-commission'].includes(params.get('view'))) returnParams.set('view', params.get('view'));
        if (/^\d+$/.test(params.get('preview_theme_id') || '')) returnParams.set('preview_theme_id', params.get('preview_theme_id'));
        // Shopify uses this flag to render the native contact success state when
        // return_to supplies an explicit destination. The fresh reference below
        // still binds measurement to this browser's actual submission attempt.
        returnParams.set('contact_posted', 'true');
        returnParams.set('hok_inquiry_ref', id);
        returnTo.value = `${window.location.pathname}?${returnParams.toString()}#${form.id}`;
        receipt.reference = id; receipt.tracking = 'submission-pending'; report();
        // No preventDefault, fetch or custom POST: validation/challenge/delivery remain native.
      });
    }
    let timer;
    let attempts = 0;
    let privacyRequested = false;
    const update = () => {
      syncAttribution();
      if (!permission('analyticsProcessingAllowed') && !permission('marketingAllowed') && window.Shopify?.customerPrivacy) write(PENDING, null);
      if (state !== 'success') { report(); return; }
      const pending = read(PENDING);
      if (!valid(pending) || returnedReference !== pending.id) {
        receipt.tracking = 'no-matching-confirmed-submission'; report(); return;
      }
      receipt.reference = pending.id;
      const review = preview || pending.review;
      const tagReady = typeof window.gtag === 'function';
      receipt.ga = review ? 'review-suppressed' : pending.ga ? 'already-attempted' : !gaDestination ? 'disabled' :
        !permission('analyticsProcessingAllowed') ? 'consent-not-allowed' : !tagReady ? 'tag-unavailable' : 'eligible';
      receipt.ads = review ? 'review-suppressed' : pending.ads ? 'already-attempted' : !adsDestination ? 'disabled' :
        !(permission('marketingAllowed') && permission('saleOfDataAllowed')) ? 'consent-not-allowed' : !tagReady ? 'tag-unavailable' : 'eligible';
      const ga = receipt.ga === 'eligible';
      const ads = receipt.ads === 'eligible';
      receipt.tracking = 'server-confirmed';
      if (ga || ads) {
        // At-most-once attempts: persist consumption before calling the existing tag.
        if (!write(PENDING, { ...pending, ga: pending.ga || ga, ads: pending.ads || ads })) {
          receipt.tracking = 'confirmed-storage-unavailable'; report(); return;
        }
        const context = { page_location: window.location.origin + window.location.pathname, page_referrer: '', page_title: 'Stainless Steel Sculptures & Fountains | House of Koval' };
        if (ga) {
          try {
            window.gtag('event', 'sculpture_project_inquiry', { send_to: gaDestination, inquiry_id: pending.id,
              product_family: 'stainless_steel_sculpture', piece: pending.piece, project_type: pending.project, ...context });
            receipt.ga = 'queued';
          } catch { receipt.ga = 'tag-call-failed-no-retry'; }
        }
        if (ads) {
          try {
            window.gtag('config', adsDestination.split('/')[0], { send_page_view: false });
            window.gtag('event', 'conversion', { send_to: adsDestination, transaction_id: pending.id, ...context });
            receipt.ads = 'queued';
          } catch { receipt.ads = 'tag-call-failed-no-retry'; }
        }
        receipt.tracking = 'events-attempted';
      }
      report();
      if ([receipt.ga, receipt.ads].some(value => ['tag-unavailable', 'consent-not-allowed'].includes(value)) && ++attempts < 30) {
        window.clearTimeout(timer); timer = window.setTimeout(update, 1000);
      }
    };
    const loadPrivacy = () => {
      if (!window.Shopify?.customerPrivacy && !privacyRequested && typeof window.Shopify?.loadFeatures === 'function') {
        privacyRequested = true;
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) update(); });
      }
    };
    document.addEventListener('visitorConsentCollected', update);
    window.addEventListener('pageshow', update);
    update(); loadPrivacy();
  };
  document.querySelectorAll('[data-stainless-inquiry-form]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-stainless-inquiry-form]').forEach(initialize);
  });
})();
